import { render, staticRenderFns } from "./VerifyMessageLayout.vue?vue&type=template&id=28db55aa&scoped=true&functional=true&"
import script from "./VerifyMessageLayout.vue?vue&type=script&lang=js&"
export * from "./VerifyMessageLayout.vue?vue&type=script&lang=js&"
import style0 from "./VerifyMessageLayout.vue?vue&type=style&index=0&id=28db55aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "28db55aa",
  null
  
)

export default component.exports